// extracted by mini-css-extract-plugin
module.exports = {"NewDevelopersBlock":"NewDeveloper_NewDevelopersBlock__3hDQz"};